import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=1052d39b"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=1052d39b&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wedevs/Herd/dokan-core/wp-content/plugins/dokan-pro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1052d39b')) {
      api.createRecord('1052d39b', component.options)
    } else {
      api.reload('1052d39b', component.options)
    }
    module.hot.accept("./CategoryList.vue?vue&type=template&id=1052d39b", function () {
      api.rerender('1052d39b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/request-for-quotation/assets/src/js/admin/components/CategoryList.vue"
export default component.exports